import { useState } from 'react'
import { Redirect } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import EmailForm from 'components/EmailForm'
import ErrorDialog from 'components/ErrorDialog'
import Panel from 'components/Panel'
import useAuth, { sendSignInLink } from 'lib/auth'
import { ReactComponent as MailedImage } from 'resources/images/mailed.svg'

export default function LoginPage() {
  const { user } = useAuth()
  const [error, setError] = useState(null)
  const [mailed, setMailed] = useState(false)

  const handleSubmit = email => {
    return sendSignInLink(email)
      .then(() => setMailed(true))
      .catch(e => {
        e.message = 'エラーが発生しました。大変お手数ですがしばらくして再度お試しください'
        setError(e)
      })
  }

  if (mailed) {
    return (
      <Panel centered>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography align="center" sx={{ mb: 3 }} variant="h2">
            認証メール送信完了
          </Typography>
          <Box sx={{ mb: 4 }}>
            <MailedImage style={{ width: 200, height: 'auto' }} />
          </Box>
          <Typography varinat="body1">
            認証メールを送信しました。
            <br />
            受信 BOX をご確認ください。
          </Typography>
        </div>
      </Panel>
    )
  }

  if (user) {
    return <Redirect to="/" />
  }

  return (
    <>
      <Panel centered>
        <EmailForm onSubmit={handleSubmit} />
      </Panel>
      {Boolean(error) && <ErrorDialog error={error.message} onClose={() => setError(null)} />}
    </>
  )
}
